import INotificationState from '../../interfaces/states/INotificationState';
import { ImmerReducer, createActionCreators, createReducerFunction } from 'immer-reducer';
import { INotification } from '../../interfaces/dtos/INotification';

const initialState: INotificationState = {
  notifications: [],
};

class NotificationReducer extends ImmerReducer<INotificationState> {
  public setNotificationInfo(notifications: INotification[]): void {
    this.draftState.notifications = notifications;
  }

  public deleteNotification(notificationId: string, instanceId: string): void {
    const filteredNotificationData = this.draftState.notifications.filter(
      value => value.notificationId !== notificationId && value.instanceId !== instanceId,
    );
    this.draftState.notifications = filteredNotificationData;
  }
}

export const NotificationActions = createActionCreators(NotificationReducer);
export const NotificationReducerFunction = createReducerFunction(NotificationReducer, initialState);
